var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsEmptyState = function SvgNotificationsEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 184 152"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C2",
    d: "M91.797 151.228c37.443 0 67.797-5.672 67.797-12.668 0-6.997-30.354-12.668-67.797-12.668S24 131.563 24 138.56c0 6.996 30.354 12.668 67.797 12.668Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C2",
    fillRule: "evenodd",
    d: "m146.034 101.344-23.925-29.445c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L37.56 101.344v13.383h108.475v-13.383h-.001Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "evenodd",
    d: "M57.83 31.67h67.933a4.002 4.002 0 0 1 4 4v93.344a3.999 3.999 0 0 1-4 4H57.83a4 4 0 0 1-4-4V35.67a4 4 0 0 1 4-4Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0E6",
    fillRule: "evenodd",
    d: "M66.678 41.623h50.237a2 2 0 0 1 2 2V68.58a2 2 0 0 1-2 2H66.678a2 2 0 0 1-2-2V43.623a2 2 0 0 1 2-2Zm.262 39.814h49.713a2.26 2.26 0 0 1 1.599 3.862 2.26 2.26 0 0 1-1.599.662H66.94a2.262 2.262 0 1 1 0-4.524Zm0 11.763h49.713a2.26 2.26 0 0 1 2.262 2.263 2.26 2.26 0 0 1-2.262 2.262H66.94a2.262 2.262 0 1 1 0-4.525Zm78.873 43.502c-.775 3.071-3.497 5.36-6.735 5.36H44.515c-3.238 0-5.96-2.29-6.734-5.36a7.305 7.305 0 0 1-.222-1.79v-33.567h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393v-.012c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569a7.33 7.33 0 0 1-.221 1.789Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "evenodd",
    d: "m149.121 33.292-6.83 2.65a1.003 1.003 0 0 1-1.045-.201.995.995 0 0 1-.272-1.029l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C2",
    d: "M170.304 21.365c1.574 0 2.849-1.26 2.849-2.815 0-1.554-1.275-2.815-2.849-2.815-1.573 0-2.849 1.26-2.849 2.815s1.276 2.815 2.849 2.815Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C2",
    fillRule: "evenodd",
    d: "M155.348 21.013h-5.698l2.898-4.926 2.8 4.926Zm3.561-4.926h4.985v4.926h-4.985v-4.926Z",
    clipRule: "evenodd"
  })));
};
export default SvgNotificationsEmptyState;